import styles from './styles.module.scss'

import { Card, Button, Input } from 'antd';

import { useContext, useState } from 'react';

import { UserContext } from '@/context/user';
import { setUserContextItem, removeUserContextItem } from '@/persistence/user_context';

export const GoogleUserIdAttribute = ({ onDone }: AttributeInput) => {
  const { userId, setUserId } = useContext(UserContext)
  const [givenUserId, setGivenUserId] = useState<string>('')
  const [mixedUserId, setMixedUserId] = useState<string>('')

  const onInputChange = (e: any) => {
    const value = e.target.value

    setGivenUserId(value)

    if (value) {
      const firstCharacter = value[0]
      const length = value.length
      const nextMixedUserId = `${firstCharacter}_${length}`
      setMixedUserId(nextMixedUserId)
    }
  }

  const onReset = () => {
    removeUserContextItem({ key: 'user_id' })
    setUserId(undefined)
  }

  const onSet = () => {
    setUserContextItem({ key: 'user_id', value: mixedUserId })
    setUserId({ id: mixedUserId })

    window.location.reload()

    if (onDone) { onDone() }
  }

  const onTest = () => {
    window.gtag('event', 'test', {
      hello: 'world'
    });
  }

  const headStyle = {
    backgroundColor: '#fff1f0'
  }

  const bodyMinHeightStyle = {
    minHeight: '160px'
  }

  const bodyStyle = {
    backgroundColor: '#fff1f0',
    ...bodyMinHeightStyle,
  }

  return (
    <Card
      title="사용자 ID"
      headStyle={!userId ? headStyle : {}}
      bodyStyle={!userId ? bodyStyle: bodyMinHeightStyle }
      bordered={true}>
      {
        (userId && userId.id) && (
          <>
            <div className={styles.rowInput}>
              <Input size="large" value={userId.id} disabled={true} />
            </div>
            <div className={styles.rowButton}>
              <Button type="dashed" danger onClick={(e) => onReset() }>초기화하기</Button>
              <Button style={{ marginLeft: '14px' }}type="primary" onClick={(e) => onTest() }>테스트</Button>
            </div>
          </>
        )
      }
      {
        (!userId || !userId.id) && (
          <>
            <div className={styles.rowInput}>
              <Input size="large" placeholder="사용자 ID를 입력해주세요" onChange={(e) => onInputChange(e) } />
              {
                (givenUserId && mixedUserId) && (
                  <Input style={{ marginTop: '14px' }} size="large" value={mixedUserId} disabled={true} placeholder="암호화된 사용자 ID입니다" />
                )
              }
            </div>
            <div className={styles.rowButton}>
              <Button type="primary" onClick={(e) => onSet() }>설정하기</Button>
            </div>
          </>
        )
      }
    </Card>
  )
}
